import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatDialogActions, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { NgIf, NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatOption, MatSelect, MatSelectModule, MatSelectTrigger } from '@angular/material/select';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatIcon, MatIconModule } from '@angular/material/icon';

import { VariantStore } from '../../../../stores/variant.store';
import { CreateVariantKeyDialogComponent } from '../create-variant-key-dialog/create-variant-key-dialog.component';

@Component({
  selector: 'app-create-variant-dialog',
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    MatFormFieldModule,
    FormsModule,
    MatFormField,
    MatInput,
    MatSelect,
    MatOption,
    MatButton,
    MatIcon,
    MatIconModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatSelect,
    MatSelectTrigger
  ],
  templateUrl: './create-variant-dialog.component.html',
  styleUrls: ['./create-variant-dialog.component.scss']
})
export class CreateVariantDialogComponent {

  variant_key: any;
  price = 0;
  attributes: { key: string; value: string }[] = [];

  constructor(
    public dialogRef: MatDialogRef<CreateVariantDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    public variantStore: VariantStore
  ) { }

  async ngOnInit() {
    await this.variantStore.loadVariantKeys();
  }

  addAttributeField() {
    this.attributes.push({ key: '', value: '' });
  }

  removeAttribute(i: number) {
    this.attributes.splice(i, 1);
  }

  // MAIN SUBMIT FOR VARIANT CREATION
  submit() {
    const attrs: Record<string, string> = {};
    this.attributes.forEach(a => {
      if (a.key.trim() && a.value.trim()) {
        attrs[a.key.trim()] = a.value.trim();
      }
    });

    this.dialogRef.close({
      variant_key: this.variant_key,
      price: this.price,
      attributes: attrs
    });
  }

  cancel() {
    this.dialogRef.close(null);
  }

  // OPEN SECOND DIALOG: Create Variant Key
  async openCreateVariantKeyDialog() {
    const dialogRef = this.dialog.open(CreateVariantKeyDialogComponent, {
      width: '450px'
    });

    const result = await dialogRef.afterClosed().toPromise();
    if (!result) return;

    try {
      await this.variantStore.createVariantKey(result.key_code, result.display_name);

      this.variant_key = null;

    } catch (err) {
      console.error('Failed to create variant key:', err);
    }
  }

  getDisplayNameForKey(keyCode: string): string {
    const key = this.variantStore.variantKeys().find(k => k.key_code === keyCode);
    return key ? key.display_name : '';
  }


  async deleteVariantKey(key: any) {
    await this.variantStore.deleteVariantKey(key.key_code);
  }
}
